import "./App.css";
import MyNavbar from "./components/MyNavbar";
import "bootstrap/dist/css/bootstrap.min.css";
import Tvshow from "./components/Tvshow";
import Homepage from "./components/Homepage";
import MyFooter from "./components/MyFooter";
import MyHeader from "./components/MyHeader";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import FilmDetails from "./components/FilmDetails";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import RisultatoRicerca from "./components/RisultatoRicerca";
import MyList from "./components/MyList";
import { Helmet } from "react-helmet";

function App() {
  return (
    <BrowserRouter>
      <div>
        <Helmet>
          <title>Cinetrailer | Benvenuti sul nostro sito</title>
          <meta name="description" content="Benvenuti sul nostro sito, esplora film, serie TV, dettagli e altro ancora!" />
          <meta name="keywords" content="Cinetrailer,film, cinetrailer italia,alfio battiato,serie tv, trailer, streaming" />

          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "WebSite",
              "name": "Trailer Film - Cinetrailer",
              "url": "https://cinetrailer03.netlify.app/",
              "description": "Guarda i trailer dei migliori film in streaming.",
              "potentialAction": {
                "@type": "SearchAction",
                "target": "https://cinetrailer03.netlify.app/search?q={search_term}",
                "query-input": "required name=search_term"
              }
            })}
          </script>

        </Helmet>

        <MyNavbar />
        <Routes>
          <Route
            path="/"
            element={
              <>
                <MyHeader />
                <Homepage />
              </>
            }
          ></Route>
          <Route path="/Tvshow" element={<><MyHeader /><Tvshow /></>} />
          <Route path="/Detail/:type/:id" element={<FilmDetails />} />
          <Route path="/search" element={<RisultatoRicerca />} />
          <Route path="/MyList" element={<MyList />} />
        </Routes>

        <MyFooter />
      </div>
    </BrowserRouter>
  );
}

export default App;

